import React from 'react';

/**
 * 상담사 연결 안내 멘트(고정 꼬리말) 컴포넌트.
 * AI 답변과 관련 법령 근거가 모두 출력된 후 하단에 표시됩니다.
 */
const ConsultationFooter = () => {
    return (
        <div className="mt-6 pt-6 border-t border-gray-100/80">
            <div className="text-[13px] text-gray-500 leading-relaxed font-normal bg-gray-50/50 p-4 rounded-2xl border border-gray-50">
                답변이 도움이 되셨나요? 혹시 내용이 이해하기 어렵거나 개별 현장에 맞춰 추가로 궁금한 점이 있으시다면, 언제든지 편하게 연락해 주세요! 아토스 담당자가 친절하게 안내해 드리겠습니다.<br />
                <span className="inline-flex items-center gap-1 mt-2">
                    📞 문의 전화 : <strong className="text-blue-600 font-bold ml-1">02-3442-7111</strong>
                </span>
            </div>
        </div>
    );
};

export default ConsultationFooter;
